(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}


var $8e9a44893dbf8eec$exports = {};
$8e9a44893dbf8eec$exports = JSON.parse('{"bagels":["Plain","Sesame","Poppy","Onion","Garlic","Salt","Everything","100% Whole Wheat","Everything-Wheat","Cinnamon Raisin"],"cream_cheese":[{"name":"Plain","price":0.75},{"name":"Herb","price":0.9},{"name":"Jalape\xf1o Lime","price":0.9},{"name":"Olive","price":0.9},{"name":"Vegetable","price":0.9},{"name":"Walnut Raisin","price":0.9},{"name":"Honey Pecan","price":0.9},{"name":"Blueberry","price":0.9},{"name":"Strawberry","price":0.9},{"name":"Neufch\xe2tel","price":0.9}],"meats":[{"name":"Turkey Breast","price":4.55},{"name":"Smoked Turkey Breast","price":4.65},{"name":"Ham","price":4.55},{"name":"Roast Beef","price":5.15},{"name":"Pastrami","price":5.25},{"name":"Corned Beef","price":5.25},{"name":"Sausage","price":3.6},{"name":"Pulled Chicken (w/BBQ)","price":4.2},{"name":"Pulled Chicken (no BBQ)","price":4.2},{"name":"Salami","price":4.35},{"name":"BLT","price":5.05}],"toppings":[{"name":"Lettuce","price":0},{"name":"Mayo","price":0},{"name":"Mustard","price":0},{"name":"Onion","price":0},{"name":"Horseradish","price":0},{"name":"Butter/Smart Balance","price":0},{"name":"Tomato","price":0.4},{"name":"Sprouts","price":0.45},{"name":"Bacon","price":1.35},{"name":"Cucumber","price":0.35},{"name":"Watercross","price":0.5},{"name":"Fig Spread","price":0.8},{"name":"Pesto","price":0.9},{"name":"Kalamata Spread","price":0.95},{"name":"Hummus","price":0.85},{"name":"Avocado","price":1.05},{"name":"Feta Spread","price":0.85},{"name":"Pepper Spread","price":0.5},{"name":"Egg","price":1.3},{"name":"Swiss Cheese","price":0.5},{"name":"Provolone Cheese","price":0.5},{"name":"Muenster Cheese","price":0.5},{"name":"Cheddar Cheese","price":0.5},{"name":"American Cheese","price":0.5}],"item_classes_base":"flex","item_classes_unselected":"bg-white hover:bg-sky-50 hover:font-semibold","item_classes_selected":"bg-sky-100 font-bold hover:font-semibold hover:bg-sky-50"}');


const $129e026baf96a347$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
async function $129e026baf96a347$var$write_words_slowly(text, element) {
    var content = "";
    for (let t of text.split(" ")){
        content += t + " ";
        element.textContent = content;
        await $129e026baf96a347$var$sleep(100);
    }
}
const $129e026baf96a347$export$37c89899d344aa0a = "???";
const $129e026baf96a347$export$9811ac3b0170bc = "bagel";
const $129e026baf96a347$export$5709f7d78ff897de = "cc";
const $129e026baf96a347$export$a928fc1b50c9b306 = "meat";
const $129e026baf96a347$export$9fe228bc1d89bf5 = "top";
var $129e026baf96a347$export$b52c92f6507b8829;
(function(pre_id) {
    pre_id[pre_id["bagel"] = $129e026baf96a347$export$9811ac3b0170bc] = "bagel";
    pre_id[pre_id["cc"] = $129e026baf96a347$export$5709f7d78ff897de] = "cc";
    pre_id[pre_id["meat"] = $129e026baf96a347$export$a928fc1b50c9b306] = "meat";
    pre_id[pre_id["top"] = $129e026baf96a347$export$9fe228bc1d89bf5] = "top";
})($129e026baf96a347$export$b52c92f6507b8829 || ($129e026baf96a347$export$b52c92f6507b8829 = {}));
function $129e026baf96a347$export$1a5719c28f485848(name) {
    return name.toLowerCase().replaceAll(" ", "-");
}
// export enum BagelType {
//   Plain = "plain",
//   Sesame = "sesame",
//   Poppy = "poppy",
//   Onion = "onion",
//   Garlic = "garlic",
//   Salt = "salt",
//   Everything = "everything",
//   WholeWheat = "100% whole wheat",
//   EverythingWheat = "everything wheat",
//   CinnamonRaisin = "cinnamon raisin"
// }
function $129e026baf96a347$var$validateBagel(b) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).bagels.includes(b)) return true;
    else console.log("Unknown bagel type: " + b);
}
function $129e026baf96a347$var$starts_with_vowel(query) {
    if (query.length > 0) {
        let first_char_lower = query[0].toLowerCase();
        switch(first_char_lower){
            case "a":
                return true;
            case "e":
                return true;
            case "i":
                return true;
            case "o":
                return true;
            case "u":
                return true;
        }
    }
    return false;
}
function $129e026baf96a347$var$sentence_capitalization(query) {
    if (query.length > 0) {
        let start = query[0].toUpperCase();
        let rest = query.slice(1);
        return start + rest;
    } else return "";
}
function $129e026baf96a347$var$safe_add_item(item, list) {
    const idx = list.indexOf(item);
    if (idx < 0) list.push(item);
    return list;
}
function $129e026baf96a347$var$removeItem(item, list) {
    let result = list.filter((obj)=>obj !== item);
    return result;
}
function $129e026baf96a347$var$getRandomItem(arr) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
}
class $129e026baf96a347$export$73416d108975c6c7 {
    selectBagel(b) {
        $129e026baf96a347$var$validateBagel(b);
        this.bagel = b;
        this.write_out();
    }
    deselectBagel() {
        this.bagel = $129e026baf96a347$export$37c89899d344aa0a;
        this.write_out();
    }
    toggleBagel(b) {
        if (b == this.bagel) this.deselectBagel();
        else this.selectBagel(b);
    }
    selectCreamCheese(c) {
        this.cream_cheese = c;
        this.write_out();
    }
    deselectCreamCheese() {
        this.cream_cheese = $129e026baf96a347$export$37c89899d344aa0a;
        this.write_out();
    }
    toggleCreamCheese(cc) {
        if (cc == this.cream_cheese) this.deselectCreamCheese();
        else this.selectCreamCheese(cc);
    }
    selectMeat(m) {
        this.meats = $129e026baf96a347$var$safe_add_item(m, this.meats);
        this.meats.sort();
        this.write_out();
    }
    deselectMeat(m) {
        this.meats = $129e026baf96a347$var$removeItem(m, this.meats);
        this.meats.sort();
        this.write_out();
    }
    toggleMeat(m) {
        if (this.meats.indexOf(m) != -1) this.deselectMeat(m);
        else this.selectMeat(m);
    }
    selectTopping(t) {
        this.toppings = $129e026baf96a347$var$safe_add_item(t, this.toppings);
        this.toppings.sort();
        this.write_out();
    }
    deselectTopping(t) {
        this.toppings = $129e026baf96a347$var$removeItem(t, this.toppings);
        this.toppings.sort();
        this.write_out();
    }
    toggleTopping(t) {
        if (this.toppings.indexOf(t) != -1) this.deselectTopping(t);
        else this.selectTopping(t);
    }
    randomize() {
        console.log("Randomizing...");
        this.bagel = $129e026baf96a347$var$getRandomItem((0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).bagels);
        this.cream_cheese = $129e026baf96a347$var$getRandomItem((0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).cream_cheese).name;
        const num_meats = Math.floor(Math.random() * 2);
        this.meats = [];
        for(var _i = 0; _i < num_meats; _i++){
            const new_meat = $129e026baf96a347$var$getRandomItem((0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).meats).name;
            this.meats = $129e026baf96a347$var$safe_add_item(new_meat, this.meats);
        }
        const num_toppings = Math.floor(Math.random() * 4);
        this.toppings = [];
        for(var _i = 0; _i < num_toppings; _i++){
            const new_topping = $129e026baf96a347$var$getRandomItem((0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).toppings).name;
            this.toppings = $129e026baf96a347$var$safe_add_item(new_topping, this.toppings);
        }
        this.write_out();
    }
    prompt_str() {
        var words = [];
        if (this.cream_cheese == $129e026baf96a347$export$37c89899d344aa0a) {
            let preposition = "a";
            if ($129e026baf96a347$var$starts_with_vowel(this.bagel)) preposition = "an";
            words.push(preposition);
            words.push(this.bagel);
            words.push("bagel");
        } else {
            words.push(this.cream_cheese);
            words.push("cream");
            words.push("cheese");
            words.push("on");
            let preposition = "a";
            if ($129e026baf96a347$var$starts_with_vowel(this.bagel)) preposition = "an";
            words.push(preposition);
            words.push(this.bagel);
            words.push("bagel");
        }
        let sandwich_comps = [];
        for (const meat_name of this.meats)sandwich_comps.push(meat_name);
        for (const top_name of this.toppings)sandwich_comps.push(top_name);
        if (sandwich_comps.length > 0) {
            words.push("with");
            for(var sc_idx = 0; sc_idx < sandwich_comps.length; sc_idx += 1){
                const item_name = sandwich_comps[sc_idx];
                let new_word = item_name;
                if (sc_idx != sandwich_comps.length - 1) {
                    if (sc_idx < sandwich_comps.length - 2) new_word = new_word.concat(",");
                    else if (sc_idx == sandwich_comps.length - 2) {
                        if (sandwich_comps.length == 2) new_word = new_word.concat(" and");
                        else new_word = new_word.concat(", and");
                    }
                }
                words.push(new_word);
            }
        }
        var prompt = words.join(" ");
        let final_prompt = $129e026baf96a347$var$sentence_capitalization(prompt);
        return final_prompt;
    }
    write_out() {
        let message = this.prompt_str();
        let prompt = document.getElementById("prompt");
        $129e026baf96a347$var$write_words_slowly(message, prompt);
    }
    constructor(){
        this.bagel = $129e026baf96a347$export$37c89899d344aa0a;
        this.cream_cheese = $129e026baf96a347$export$37c89899d344aa0a;
        this.meats = [];
        this.toppings = [];
    }
}



console.log((0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))));
function $253ce2a319769a4a$var$set_classes_to_selected(el) {
    for (const unsel_class of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).item_classes_unselected.split(" "))el.classList.remove(unsel_class);
    for (const sel_class of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).item_classes_selected.split(" "))el.classList.add(sel_class);
}
function $253ce2a319769a4a$var$set_classes_to_unselected(el) {
    for (const sel_class of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).item_classes_selected.split(" "))el.classList.remove(sel_class);
    for (const unsel_class of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).item_classes_unselected.split(" "))el.classList.add(unsel_class);
}
function $253ce2a319769a4a$var$mark_item(pi, id) {
    let safeId = (0, $129e026baf96a347$export$1a5719c28f485848)(id);
    let element = document.getElementById(pi.valueOf() + "-" + safeId);
    if (element instanceof HTMLElement) {
        // console.log(element.classList);
        $253ce2a319769a4a$var$set_classes_to_selected(element);
        console.log("marked " + pi.valueOf() + "-" + safeId);
    } else console.log("33 could not locate " + pi.valueOf() + "-" + safeId);
// unhide the span:
// let marker_element: HTMLElement | null = document.getElementById(pi.valueOf() + "-" + safeId + '-marker');
// if (marker_element instanceof HTMLElement) {
//   // console.log(element.classList);
//   marker_element.classList.remove("hidden");
// } else {
//   console.log("21 could not locate " + pi.valueOf() + '-' + safeId + '-marker');
// }
}
function $253ce2a319769a4a$var$unmark_all() {
    // console.log("unmark all");
    for (let bagel_id of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).bagels)$253ce2a319769a4a$var$unmark_item((0, $129e026baf96a347$export$b52c92f6507b8829).bagel, bagel_id);
    for (const cc_obj of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).cream_cheese)$253ce2a319769a4a$var$unmark_item((0, $129e026baf96a347$export$b52c92f6507b8829).cc, cc_obj.name);
    for (const meat_obj of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).meats)$253ce2a319769a4a$var$unmark_item((0, $129e026baf96a347$export$b52c92f6507b8829).meat, meat_obj.name);
    for (const top_obj of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).toppings)$253ce2a319769a4a$var$unmark_item((0, $129e026baf96a347$export$b52c92f6507b8829).top, top_obj.name);
}
function $253ce2a319769a4a$var$unmark_item(pi, id) {
    let safeId = (0, $129e026baf96a347$export$1a5719c28f485848)(id);
    let element = document.getElementById(pi.valueOf() + "-" + safeId);
    if (element instanceof HTMLElement) // console.log(element.classList);
    $253ce2a319769a4a$var$set_classes_to_unselected(element);
    else console.log("34 could not locate " + pi.valueOf() + "-" + safeId);
// hide the span?
}
let $253ce2a319769a4a$var$sandwich = new (0, $129e026baf96a347$export$73416d108975c6c7)();
function $253ce2a319769a4a$var$action_button_clicked(_) {
    // console.log("select topping: " + id);
    $253ce2a319769a4a$var$sandwich.randomize();
    $253ce2a319769a4a$var$update_chart_selections();
    let element = document.getElementById("action_call");
    element.innerText = "Roll again";
}
function $253ce2a319769a4a$var$bagel_clicked(id) {
    // console.log("select bagel: " + id);
    $253ce2a319769a4a$var$sandwich.toggleBagel(id);
    // mark_item(pre_id.bagel, id);
    $253ce2a319769a4a$var$update_chart_selections();
}
function $253ce2a319769a4a$var$cr_cheese_clicked(id) {
    // console.log("select cream cheese: " + id);
    $253ce2a319769a4a$var$sandwich.toggleCreamCheese(id);
    $253ce2a319769a4a$var$update_chart_selections();
}
function $253ce2a319769a4a$var$meat_clicked(id) {
    // console.log("select meat: " + id);
    $253ce2a319769a4a$var$sandwich.toggleMeat(id);
    $253ce2a319769a4a$var$update_chart_selections();
}
function $253ce2a319769a4a$var$top_clicked(id) {
    // console.log("select topping: " + id);
    $253ce2a319769a4a$var$sandwich.toggleTopping(id);
    $253ce2a319769a4a$var$update_chart_selections();
}
function $253ce2a319769a4a$var$update_chart_selections() {
    console.log($253ce2a319769a4a$var$sandwich);
    $253ce2a319769a4a$var$unmark_all();
    if ($253ce2a319769a4a$var$sandwich.bagel != (0, $129e026baf96a347$export$37c89899d344aa0a)) $253ce2a319769a4a$var$mark_item((0, $129e026baf96a347$export$b52c92f6507b8829).bagel, $253ce2a319769a4a$var$sandwich.bagel);
    if ($253ce2a319769a4a$var$sandwich.cream_cheese != (0, $129e026baf96a347$export$37c89899d344aa0a)) $253ce2a319769a4a$var$mark_item((0, $129e026baf96a347$export$b52c92f6507b8829).cc, $253ce2a319769a4a$var$sandwich.cream_cheese);
    if ($253ce2a319769a4a$var$sandwich.meats.length > 0) for (const meat_id of $253ce2a319769a4a$var$sandwich.meats)$253ce2a319769a4a$var$mark_item((0, $129e026baf96a347$export$b52c92f6507b8829).meat, meat_id);
    if ($253ce2a319769a4a$var$sandwich.toppings.length > 0) for (const top_id of $253ce2a319769a4a$var$sandwich.toppings)$253ce2a319769a4a$var$mark_item((0, $129e026baf96a347$export$b52c92f6507b8829).top, top_id);
// #map
}
function $253ce2a319769a4a$var$register_item_listener(pi, id, click_func) {
    let safeId = (0, $129e026baf96a347$export$1a5719c28f485848)(id);
    let item_id = pi.valueOf() + "-" + safeId;
    $253ce2a319769a4a$var$register_listener(item_id, click_func, id);
}
function $253ce2a319769a4a$var$register_listener(id, click_func, passed_arg) {
    var element = document.getElementById(id);
    if (element instanceof HTMLElement) element.onclick = function() {
        click_func(passed_arg);
    };
    else console.log("issue on " + id);
}
// Register listeners
$253ce2a319769a4a$var$register_listener("action_call", $253ce2a319769a4a$var$action_button_clicked, null);
for (let bagelName of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).bagels)$253ce2a319769a4a$var$register_item_listener((0, $129e026baf96a347$export$b52c92f6507b8829).bagel, bagelName, $253ce2a319769a4a$var$bagel_clicked);
for (let cc_obj of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).cream_cheese)// let cc_id = safe_name(cc_obj.name);
$253ce2a319769a4a$var$register_item_listener((0, $129e026baf96a347$export$b52c92f6507b8829).cc, cc_obj.name, $253ce2a319769a4a$var$cr_cheese_clicked);
for (let meat_obj of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).meats)// let cc_id = safe_name(cc_obj.name);
$253ce2a319769a4a$var$register_item_listener((0, $129e026baf96a347$export$b52c92f6507b8829).meat, meat_obj.name, $253ce2a319769a4a$var$meat_clicked);
for (let top_obj of (0, (/*@__PURE__*/$parcel$interopDefault($8e9a44893dbf8eec$exports))).toppings)// let cc_id = safe_name(cc_obj.name);
$253ce2a319769a4a$var$register_item_listener((0, $129e026baf96a347$export$b52c92f6507b8829).top, top_obj.name, $253ce2a319769a4a$var$top_clicked);
 // console.log("complete!");

})();
//# sourceMappingURL=index.f2705bc9.js.map
